<template>
  <div>
    <!-- multiple  -->
    <div class="d-flex justify-content-between">
      <b-dropdown
        v-if="type"
        text="Select Actions"
        class="d-flex align-items-center mx-3 top-page-btn m-md-2 users-action-ddl"
        variant="primary"
        size="sm"
      >
        <template v-slot:button-content>
          <span class="custom-fontActions">Actions for selections</span>
          <svg
            style="margin-inline-start: 8px"
            width="10"
            height="5"
            viewBox="0 0 10 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.91961 4.64098C4.01093 4.74571 4.12395 4.82975 4.25102 4.88734C4.37809 4.94494 4.51622 4.97475 4.65598 4.97475C4.79573 4.97475 4.93384 4.94494 5.06091 4.88734C5.18798 4.82975 5.30103 4.74571 5.39235 4.64098L8.87415 0.810973C9.27819 0.363973 9.11961 0.000975021 8.51254 0.000975126L0.799387 0.000976461C0.193327 0.000976566 0.0337599 0.366974 0.4378 0.810974L3.91961 4.64098Z"
              fill="white"
            />
          </svg>
        </template>

        <b-dropdown-item-button @click="setUserData(userData)">
          Change User Type for Selections
        </b-dropdown-item-button>
        <b-dropdown-item-button @click="deactivateSelections">
          Deactivate Selections
        </b-dropdown-item-button>
        <b-dropdown-item-button @click="activateSelections">
          Activate Selections
        </b-dropdown-item-button>
        <b-dropdown-item-button
          v-if="false"
          v-b-modal="'passportActionFormModal'"
          @click="saveUserDataAndType(userData, 'invite')"
        >
          Invite Selections
        </b-dropdown-item-button>
        <b-dropdown-item-button
          v-if="false"
          v-b-modal="'passportActionConfirmModal'"
          @click="saveUserDataAndType(userData, 'revoke')"
        >
          Revoke Selections
        </b-dropdown-item-button>
      </b-dropdown>
      <div v-else>
        <DxDropDownButton
          :items="items"
          :drop-down-options="{ width: 140, maxHeight: 179 }"
          :scrollable="true"
          :text="$t('common.grid.selectActions')"
          class="selectActions"
          id="selectActionsUsers"
          itemTemplate="actionsTemp"
          :disabled="isSelected"
        >
          <template #actionsTemp="{ data }">
            <div
              :class="data.id == 'rfidEnrollment' ? 'high-users-actions-seperator-one' :'users-actions-seperator' "
              class="dropdown-wrapper"
              title=""
              v-b-modal="data.modalId ? data.modalId : null"
              @click="
                !data.id || data.id == 'rfidEnrollment'
                  ? setUserData(userData)
                  : saveUserDataAndType(userData, data.id)
              "
            >
              <div
                class="dropdown-items"
                :class="{
                  'red-remove': data.text == 'Delete' || data.text == 'Archive',
                }"
                title=""
              >
                {{ data.translatedText }}
              </div>
            </div>
          </template>
        </DxDropDownButton>

        <template v-if="status.toLowerCase() != 'deactivated'">
          <button
            :disabled="isSelected"
            class="custom-signinout d-inline custom-action-grid"
            v-b-modal="status == 'Active' && 'dashboardActionOne'"
            @click="sendDataToModal(userData)"
          >
            {{ $t("common.signInOut") }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ActionsUserTypeRenderer",
  props: ["userData", "status", "type", "isSelected"],
  components: {
    DxDropDownButton,
  },
  data() {
    return {
      items: [],
    };
  },
  beforeMount() {
    this.items = [];
    this.items.push(
      {
        text: "Edit User",
        translatedText: this.$t("common.edit") + " " + this.$t("common.user"),
        modalId: "add-edit-user",
        visible: true,
      },
      {
        text: "Permissions",
        translatedText: this.$t("common.permissions"),
        modalId: "addUserPermissionsModal",
        visible:
          this.userData.id != this.loginUser &&
          this.userData.current_entity.system_user == 1 &&
          this.userData.isEntityOwner == "false",
      },
      {
        text: "Add Document",
        translatedText:
          this.$t("common.add") + " " + this.$t("common.document"),
        modalId: "addDocumentModal",
        visible:
          this.getDocuments?.length > 0 &&
          this.userData?.user_id != this.userData?.current_entity?.entity_id &&
          !this.userData?.current_entity.is_default_user,
      },
      {
        text: this.$t('users.form.invite_dashboard'),
        translatedText: this.$t("users.form.inviteToDashboard"),
        modalId: "passportActionFormModal",
        id: "invite",
        visible:
          this.userData.user_id != this.userData.current_entity.entity_id &&
          this.userData.current_entity &&
          this.userData.current_entity.system_user == 0 &&
          this.userData.current_entity.is_active == 1 &&
          !this.userData.current_entity.is_default_user &&
          this.userData.isEntityOwner == "false" &&
          this.userData.id != this.loginUser,
      },
      {
        text: "Print QuickPass",
        translatedText: "Print QuickPass",
        visible:!this.userData?.current_entity.is_default_user,
        modalId: "quickpassFormModal",
      },
      {
        text: "Revoke from Dashboard",
        translatedText: this.$t("users.form.revokeFromDashboard"),
        modalId: "passportActionConfirmModal",
        id: "revoke",
        visible:
          this.userData.id != this.loginUser &&
          this.userData.user_id != this.userData.current_entity.entity_id &&
          this.userData.current_entity &&
          this.userData.current_entity.system_user == 1 &&
          this.userData.current_entity.is_active == 1 &&
          !this.userData.current_entity.is_default_user &&
          this.userData.isEntityOwner == "false",
      },
      {
        text: "RFID Enrollment",
        translatedText: this.$t("common.rfidEnrollment"),
        id: "rfidEnrollment",
        modalId: "rfidEnrollmentModal",
        visible:
          this.userData.user_id != this.userData.current_entity.entity_id &&
          !this.userData.current_entity.is_default_user &&
          JSON.parse(this.userData.has_rfid),
      },
      {
        text: this.status == "Active" ? "Archive" : "Activate",
        translatedText:
          this.status == "Active"
            ? this.$t("users.form.archive")
            : this.$t("users.form.activate"),
        modalId: "userStatusToggleConfirmModal",
        visible:
          this.userData.user_id != this.userData.current_entity.entity_id &&
          !this.userData.current_entity.is_default_user &&
          this.userData.isEntityOwner == "false" &&
          this.userData.id != this.loginUser,
      },
      {
        text: "Delete",
        translatedText: this.$t("common.delete"),
        modalId: "deleteActionModal",
        visible:
          this.userData.user_id != this.userData.current_entity.entity_id &&
          !this.userData.current_entity.is_default_user &&
          this.userData.isEntityOwner == "false" &&
          this.userData.id != this.loginUser,
      }
    );
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("users", ["getDocuments"]),
    getOwnerId() {
      return this.currentEntity && this.currentEntity.owner_id;
    },
    userStatus() {
      return this.status == "Deactivated" ? "Active" : "Deactivate";
    },
    checkIfAdmin() {
      const userDetails = localStorage.getItem("userDetails");
      const loggedUserId = userDetails && JSON.parse(userDetails).id;
      return (
        this.userData.id == loggedUserId
          ? loggedUserId
          : null || this.userData.id == this.getOwnerId
          ? this.getOwnerId
          : null
      )
        ? false
        : true;
    },
    loginUser() {
      const userDetails = localStorage.getItem("userDetails");
      const loggedUserId = userDetails && JSON.parse(userDetails).user_id;
      return loggedUserId;
    },
  },
  methods: {
    ...mapActions("users", ["deleteUser", "denyUser"]),
    ...mapActions("modal", ["setData"]),
    sendDataToModal(data) {
      console.log(data);
      let entity = this.currentEntity;
      if (this.userData.current_entity?.image)
        this.userData.image = this.userData.current_entity.image.replace("entity_id", entity.id)+'?cacheBust='+Math.random();
      this.status == "Active"
        ? this.setData(this.userData)
        : this.$toast.error(
            "Check in can only be performed on activated users!",
            {
              position: "top-right",
            }
          );
    },
    setUserData(data) {
      console.log("setData", data);
      this.setData(data);
    },
    saveUserDataAndType(data, type) {
      this.setData({
        data,
        type,
      });
    },
    denyModal() {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to ${this.userStatus} ${this.userData.first_name} ${this.userData.last_name} ?`,
          {
            title: "Confirmation",
            size: "md",
            buttonSize: "md",
            okVariant: "primary",
            cancelVariant: "outline-secondary",
            okTitle: "Confirm",
            headerClass: "p-2 border-bottom-0 h1",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        )
        .then((proceed) => {
          proceed &&
            this.denyUser([
              {
                user_id: this.userData.id,
                active: this.status == "Deactivated" ? 1 : 0,
              },
            ]);
        });
    },
    deactivateSelections() {
      this.$bvModal
        .msgBoxConfirm(`Are you sure you want to Deactivate Selected Users ?`, {
          title: "Confirmation",
          size: "md",
          buttonSize: "md",
          okVariant: "primary",
          cancelVariant: "outline-secondary",
          okTitle: "Confirm",
          headerClass: "p-2 border-bottom-0 h1",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((proceed) => {
          proceed &&
            this.denyUser(
              Array.isArray(this.userData) &&
                this.userData.map((user) => {
                  return {
                    user_id: user.Data.id,
                    active: 0,
                  };
                })
            );
        });
    },
    activateSelections() {
      this.$bvModal
        .msgBoxConfirm(`Are you sure you want to Deactivate Selected Users ?`, {
          title: "Confirmation",
          size: "md",
          buttonSize: "md",
          okVariant: "primary",
          cancelVariant: "outline-secondary",
          okTitle: "Confirm",
          headerClass: "p-2 border-bottom-0 h1",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((proceed) => {
          proceed &&
            this.denyUser(
              Array.isArray(this.userData) &&
                this.userData.map((user) => {
                  return {
                    user_id: user.Data.id,
                    active: 1,
                  };
                })
            );
        });
    },
  },
};
</script>

<style lang="scss">
 .dx-list-item:last-of-type{
    margin-bottom: unset;
  }
  .dx-list-item:first-of-type{
    margin-top: unset;
  }

.high-users-actions-seperator-one {
  border-bottom: 5px solid #e0e0e0 !important;
}
.dropdown-wrapper {
  padding: 0;

  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    // line-height: 19px;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    // padding-inline-end: 24px !important;
    margin: 12px auto 12px auto !important;
    white-space: break-spaces;
    padding: 0 10px;
  }

  .red-remove {
    color: #f46a6a !important;
  }
}

.dx-list-item-content:hover {
  background-color: #E5F0FD
}

.users-actions-seperator {
  border-bottom: 1px solid #e0e0e0 !important;
}

.dx-scrollable-scroll.dx-state-invisible,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
  // height: 30%!important;
}
.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
</style>

<style lang="scss" scoped>
.custom-signinout {
  margin-inline-start: 16px;
  margin-inline-end: 10px;
  width: 146px;
  height: 27px;
  color: #ffffff;
  background: #2680eb;
  border-radius: 72px;
  border: none !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}
.custom-signinout:disabled {
  opacity: 0.4;
  color: #ffffff;
}
</style>
